import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../context/AuthContext';
import { quotesNamespaceLanguage } from '../utils/notificationRowTitle';

/** Namespace i18n en néerlandais si le compte est NL et la langue de facture est vide ou fr. */
export function useAccountLocaleT(namespace: string) {
  const { t, i18n } = useTranslation(namespace);
  const auth = useContext(AuthContext);
  const lng = quotesNamespaceLanguage(auth?.user?.country, auth?.user?.invoice_language);
  if (!lng) return t;
  return i18n.getFixedT(lng, namespace);
}

/** Textes devis : néerlandais si le compte est NL et la langue de facture est vide ou fr. */
export function useQuotesT() {
  const { t, i18n } = useTranslation('quotes');
  const auth = useContext(AuthContext);
  const lng = quotesNamespaceLanguage(auth?.user?.country, auth?.user?.invoice_language);
  if (!lng) return t;
  const tQuotes = i18n.getFixedT(lng, 'quotes');
  const tCommon = i18n.getFixedT(lng, 'common');
  return ((key: string, options?: object) => {
    if (key.startsWith('common:')) {
      return tCommon(key.slice('common:'.length), options as never);
    }
    return tQuotes(key, options as never);
  }) as typeof t;
}

/** Textes facturation : même règle de compte que les devis. */
export function useBillingT() {
  return useAccountLocaleT('billing');
}

/** Inscription : néerlandais dès que le pays choisi / du compte est NL. */
export function useRegistrationTForCountry(country?: string | null) {
  const { t, i18n } = useTranslation('registration');
  const lng = quotesNamespaceLanguage(country, null);
  if (!lng) return t;
  return i18n.getFixedT(lng, 'registration');
}
